import { createContext, useContext, ReactNode, FC } from 'react'
import { SponsorListingFormType } from '../sponsored-listing-form'

// Create a context
interface SponsorListingContextType {
  initialStep: number
  initialValues: Partial<SponsorListingFormType>
  isCreateListing: boolean
}

const SponsorListingContext = createContext<SponsorListingContextType | undefined>(undefined)

// Create a provider component
type SponsorListingProviderProps = {
  children: ReactNode
} & SponsorListingContextType

export const SponsoredListingProvider: FC<SponsorListingProviderProps> = ({
  initialStep,
  initialValues,
  isCreateListing,
  children
}) => {
  return (
    <SponsorListingContext.Provider
      value={{
        initialStep,
        initialValues,
        isCreateListing
      }}
    >
      {children}
    </SponsorListingContext.Provider>
  )
}

// Custom hook to use the context
export const useSponsoredListingContext = (): SponsorListingContextType => {
  const context = useContext(SponsorListingContext)
  if (!context) {
    throw new Error('useSponsoredListingContext must be used within a SponsoredListingProvider')
  }
  return context
}
